<script lang="ts">
	import type { Snippet } from "svelte";

	const { children } = $props<{ children: Snippet }>();
</script>

<div class="max-2xl p-4">
	{@render children()}
</div>
